import React, { useEffect, Suspense } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Helmet } from 'react-helmet';
import { useGetLandingQuery } from 'services/exploreApi';
import { LandingComponent, Landing, ApiObject } from 'app/types';
import Loader from 'common/components/Loader/Loader';
import ComponentPreview from 'features/backoffice/Landing/ComponentPreview';
import styles from 'features/backoffice/Landing/LandingForm.module.scss';

interface CompProps {
  landing?: ApiObject<Landing>;
}

const VariableLanding = (props: CompProps): React.ReactElement => {
  let { landing = undefined } = props;
  const { landingSlug } = useParams<{ landingSlug: string }>();
  const isLandingPath = window.location.href.includes('landings');
  const navigate = useNavigate();
  let isLoading = false;
  if (!landing) {
    ({ data: landing, isLoading } = useGetLandingQuery(landingSlug || ''));
  }
  useEffect(() => {
    if (
      !isLoading &&
      (landing === null ||
        (landing?.data.landing_path && !isLandingPath) ||
        (!landing?.data.landing_path && isLandingPath))
    ) {
      if (window.location.search?.[0] === '?') {
        navigate(window.location.pathname + window.location.search);
      } else {
        navigate('/');
      }
    }
  }, [landing]);
  return (
    <div className={`${styles.uaCms}`} style={{ display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        <title>{landing?.data.meta_title}</title>
        <meta name="description" content={landing?.data.meta_description} />
      </Helmet>
      <Suspense fallback={<Loader />}>
        {landing?.data.landing_components &&
          landing?.data.landing_components.map((landing_cmp: LandingComponent) => {
            return <ComponentPreview key={landing_cmp.id} landing_cmp={landing_cmp} />;
          })}
      </Suspense>
    </div>
  );
};

export default VariableLanding;
